const Divider = () => <hr className="border-light-grey mt-xxl" />;

export default Divider;
